import { Injectable } from "@angular/core";
import { patchState, signalState } from "@ngrx/signals";

interface CounterState {
    unreadCount: number
    unreadMessagesCount: number
    unreadClosedMessagesCount: number
}

@Injectable({
    providedIn: 'root'
})
export class CounterStore {
    counterState = signalState<CounterState>({
        unreadCount: 0,
        unreadMessagesCount: 0,
        unreadClosedMessagesCount: 0
    })

    setUnreadCount(unreadCount: number) {
        patchState(this.counterState, { unreadCount })
    }

    setUnreadMessagesCount(unreadMessagesCount: number) {
        patchState(this.counterState, { unreadMessagesCount })
    }

    setUnreadClosedMessagesCount(unreadClosedMessagesCount: number) {
        patchState(this.counterState, { unreadClosedMessagesCount })
    }
}